import { Accordion, AccordionDetails, AccordionSummary, Alert, Box, Button, capitalize, DialogContentText, IconButton, Menu, MenuItem, Select, Snackbar, Typography } from '@mui/material'
import React, { useRef } from 'react'
import PayImg from "../../../assets/payment.jpg";
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useFormik } from 'formik';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import { useState } from 'react';
import { BURL } from '../../../services/base';
import useAPI from '../../../hooks/useAPI';
import axios from 'axios';
import { formatDate, shortenText } from '../../../utils/common.utils';
import { RemoveRedEyeOutlined } from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import SmallLoader from '../../widgets/SmallLoader';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { invoiceValidationSchema } from '../../../schemas/validation.schema';

function Payment() {
    const [paymentStructures, setPaymentStructures] = useState([]);
    const [invoiceData, setInvoiceData] = useState({
        propertyId: '',
        title: '',
    });
    const [invoiceItems, setInvoiceItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [confirmLoading, setConfirmLoading] = React.useState(false);
    const [confirmationOpen, setConfirmationOpen] = React.useState(false);
    const [errorText, setErrorText] = useState('');
    const [properties, setProperties] = React.useState([]);
    const [open, setOpen] = React.useState(false);
    const [invoiceOpen, setInvoiceOpen] = React.useState(false);
    const [showToaster, setShowToaster] = React.useState(false);
    const [toasterType, setToasterType] = React.useState('success');
    const [message, setMessage] = useState(null);
    const [propertyId, setPropertyId] = React.useState('');
    const [title, setTitle] = React.useState('');
    const [invoiceId, setInvoiceId] = React.useState('');
    const [invoiceItemId, setInvoiceItemId] = React.useState('');
    const [expandedIndex, setExpandedIndex] = useState(null);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [menuInvoice, setMenuInvoice] = React.useState(null);
    const menuOpen = Boolean(anchorEl);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setInvoiceData({
            ...invoiceData,
            [name]: value
        });
    };

    const formik2 = useFormik({
        initialValues: {
            title: '',
            description: '',
            amount: ''
        },
        validationSchema: invoiceValidationSchema,
        onSubmit: (values, { resetForm }) => {
            setInvoiceItems(e => [...e, values]);
            resetForm();
        }
    });

    const { POST, GET, DELETEREQ } = useAPI();
    const type = 'property';

    const handleClick = (event, invoice) => {
        setAnchorEl(event.currentTarget);
        setMenuInvoice(invoice);
    };


    const getAllProperties = React.useCallback(async () => {
        setLoading(true);
        setErrorText(null);
        const response = await GET(`admin/properties`);
        setLoading(false);

        if (response?.status) {
            setProperties(response.data);
        } else {
            setErrorText(response.message ?? 'Request Error');
        }
        // eslint-disable-next-line
    }, []);

    // Property
    const propertyList = properties.map(property => {
        return (
            <MenuItem className='capitalize' value={property.propertyId}>{property.property.name}</MenuItem>
        )
    })
    // End of property

    const getInvoiceByType = React.useCallback(async () => {
        const token = localStorage.getItem('token');
        setErrorText(null);
        try {
            const response = await axios.get(`${BURL}admin/invoices/${type}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.status === 200) {
                const res = await response.data.data;
                setPaymentStructures(res);
            } else {
                setErrorText(response.data?.message ?? 'Request Error');
            }
        } catch (err) {
            setErrorText(err.response?.data?.message || err.message || 'Unknown error');
        } finally {
            setLoading(false);
        }
    }, [type]);


    React.useEffect(() => {
        setLoading(true);
        getAllProperties();
        getInvoiceByType();
    }, []);

    const handleSave = async () => {
        setConfirmLoading(true);
        const url = 'admin/invoices';
        const token = localStorage.getItem('token');
        const body = { type: 'property', propertyId: invoiceData.propertyId, title: invoiceData.title };
        const response = await POST(url, body, token);
        if (response?.status) {
            getInvoiceByType();
            handleClose();
            setInvoiceData({ propertyId: '', title: '' }); // ✅ Reset the form
            setConfirmLoading(false);
        } else {
            setShowToaster(true);
            setToasterType('error');
            setMessage(response.message ?? 'An error occurred while creating the invoice, try again please.');
            setConfirmLoading(false);
        }
    }

    const handleInvoiceItemSave = async () => {
        setPropertyId('');
        setInvoiceId('');
        setConfirmLoading(true);
        const url = 'admin/invoice-items';

        const token = localStorage.getItem('token');
        try {
            const body = { propertyId, invoiceId, details: invoiceItems };
            const response = await POST(url, body, token);
            if (response?.status) {
                const res = await response.data;
                setInvoiceItems([]);
                setShowToaster(true);
                setToasterType('success');
                setMessage(res.message || 'Invoice items added successfully');
                setInvoiceItems([]);
                handleClose();
                getInvoiceByType();
            }
            // else {
            //     setConfirmLoading(false);
            //     setPropertyId('');
            //     setInvoiceId('')
            //     setShowToaster(true);
            //     setToasterType('error');
            //     setMessage(response.message ?? 'An error occurred while adding invoice items, try again please.');
            // }
        } catch (err) {
            setShowToaster(true);
            setToasterType('error');
            setMessage(err.message ?? 'An error occurred while adding invoice items, try again please.');
        } finally {
            setPropertyId('');
            setInvoiceId('')
            setConfirmLoading(false);
        }
    }

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleAddItemOpen = (propertyId, invoiceId) => {
        setAnchorEl(null);
        setPropertyId(propertyId);
        setInvoiceId(invoiceId);
        setInvoiceOpen(true);
    };

    const handleDeleteInvoice = async () => {
        const token = localStorage.getItem('token');
        setConfirmLoading(true);
        setMessage(null);
        try {
            const url = `admin/invoices`;
            const response = await DELETEREQ(url, { invoiceId });
            setShowToaster(true);
            if (response.status) {
                setToasterType('success');
                setMessage(response.message);
                getInvoiceByType();
            } else {
                setToasterType('error');
                setMessage(response.message || 'An error occurred while deleting the invoice, try again please.');
            }
        } catch (err) {
            setShowToaster(true);
            setToasterType('error');
            setMessage(err.message || 'An error occurred while deleting the invoice, try again please.');
        } finally {
            setConfirmLoading(false);
            setConfirmationOpen(false);
        }
    };

    const handleDeleteInvoiceItem = async () => {
        setConfirmLoading(true);
        try {
            const url = 'admin/invoice-items';
            const token = localStorage.getItem('token');
            const body = {
                invoiceDetailIds: [invoiceItemId],
                type: "property"
            };

            const response = await DELETEREQ(url, body, token);
            setShowToaster(true);
            if (response.status) {
                setToasterType('success');
                setMessage(response.message);
                getInvoiceByType();
            } else {
                setToasterType('error');
                setMessage(response.message || 'An error occurred while deleting the invoice item, try again please.');
            }
        } catch (err) {
            setShowToaster(true);
            setToasterType('error');
            setMessage(err.message || 'An error occurred while deleting the invoice item, try again please.');
        } finally {
            setConfirmLoading(false);
            setConfirmationOpen(false);
        }

    };

    const handleClose = () => {
        setAnchorEl(null);
        setOpen(false);
        setInvoiceOpen(false);
        setMenuInvoice(null);
    };

    const handleToasterClose = () => {
        setShowToaster(false);
    };

    const handleConfirmation = (id, title) => {
        setTitle(title);
        setConfirmationOpen(true);
        setAnchorEl(null);
        if (title === 'invoice') {
            setInvoiceId(id);
        } else if (title === 'invoice_item') {
            setInvoiceItemId(id);
        }
    };

    const handleDeleteItem = (index) => {
        const newItems = [...invoiceItems];
        newItems.splice(index, 1);
        setInvoiceItems(newItems);
    };
    const loader = <SmallLoader />

    return (
        <div className='w-full'>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Create Structure</DialogTitle>
                <DialogContent>
                    <div className="pt-5 items-center w-100 gap-3 grid grid-cols-[50%,40%]">
                        <Box sx={{ minWidth: 120 }}>
                            <FormControl fullWidth >
                                <InputLabel id="demo-simple-select-label">Property</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    name='propertyId'
                                    className='capitalize'
                                    value={invoiceData.propertyId}
                                    onChange={handleInputChange}
                                    MenuProps={{
                                        style: {
                                            maxHeight: 300,
                                        },
                                    }}
                                >
                                    {propertyList}
                                </Select>
                            </FormControl>
                        </Box>
                        <TextField fullWidth id="standard-basic" label="Invoice Title" type='text' variant="outlined" name='title' value={invoiceData.title} onChange={handleInputChange} />
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={handleSave}> {!confirmLoading ? <span>Save</span> : loader}</Button>
                </DialogActions>
            </Dialog >
            <div className="px-5 mt-4 md:px-10 sm:px-3 flex justify-between items-center py-3 border-b-2 bg-white">
                <h1 className="font-bold text-[18px]"> Payment Structures</h1>
                <button className='px-4 py-2 border hover:bg-gray-200 bg-gray-100 flex items-center gap-2' onClick={handleClickOpen}><p className='font-light text-[16px]'>Create Payment</p>
                </button>
            </div>
            <div className="px-[1.22rem] md:px-4 xl:px-10 overflow-x-hidden md:w-[99%] lg:w-[100%] xl:w-[96%] 2xl:w-full mt-8">
                {loading && <SmallLoader />}
                {(errorText && !loading) && errorText}
                {!errorText && !loading && !paymentStructures.length && <div className='mt-24 flex gap-5 lg:mx-0 justify-center text-center'>{(!errorText && !loading && !paymentStructures.length)
                    && 'There is currently no payment structure. Click CREATE PAYMENT to add a payment structure.'}
                </div>}
                {
                    !loading && paymentStructures.length != 0 && (
                        <div className="w-full overflow-x-auto">
                            <div className="min-w-[700px]">
                                {/* Your header row */}
                                <div className="flex py-2 px-4 text-[#000000DE] font-medium text-sm">
                                    <div className="w-[20%] ml-3">Invoice Title</div>
                                    <div className="w-[33%] xl:w-[34%]">Property</div>
                                    <div className="w-[30%]">Created At</div>
                                    <div className="w-[15%]">Action</div>
                                </div>

                                {/* mapped items */}
                                {paymentStructures.map((invoice, i) => {
                                    return (
                                        <Accordion
                                            onChange={() => {
                                                if (expandedIndex !== i) {
                                                    setExpandedIndex(i);
                                                } else {
                                                    setExpandedIndex(null);
                                                }
                                            }}
                                            disableGutters
                                            elevation={0}
                                            square
                                            key={invoice.id || i}
                                            sx={{
                                                backgroundColor: '#f1f1f1',
                                                border: 'none',
                                                '&::before': { display: 'none' },
                                            }}
                                            className="mb-3"
                                        >
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                className="!px-4 !mb-0"
                                                sx={{
                                                    padding: 0,
                                                    margin: 0,
                                                    minHeight: 'unset',
                                                    '&::before': { display: 'none' },
                                                    '&::after': { display: 'none' },
                                                    '& .MuiAccordionSummary-content': { margin: 0 },
                                                }}
                                            >
                                                <Box onClick={(e) => e.stopPropagation()} className="flex w-full items-center text-[#000000DE] text-sm md:text-base px-1 py-2 whitespace-nowrap">
                                                    <Typography className="w-[20%] truncate pl-3 px-2 md:px-3 !font-bold text-[#0FA958] capitalize">
                                                        {invoice.title}
                                                    </Typography>
                                                    <Typography className="w-[35%] truncate pl-3 px-2 md:px-3 capitalize">
                                                        {shortenText(invoice.property.name, 20)}
                                                    </Typography>
                                                    <Typography className="w-[30%] pl-3 px-2 md:px-3">
                                                        {formatDate(invoice.createdAt)}
                                                    </Typography>
                                                    <Box className="w-[15%] flex gap-2 justify-start items-center pl-3 px-2 md:px-3">
                                                        <div className="flex justify-center items-center">
                                                            <Button
                                                                id="basic-button"
                                                                aria-controls={menuOpen ? 'basic-menu' : undefined}
                                                                aria-haspopup="true"
                                                                aria-expanded={menuOpen ? 'true' : undefined}
                                                                // onClick={handleClick}
                                                                onClick={(e) => handleClick(e, invoice)}
                                                            >
                                                                <MoreVertIcon className="text-[#6C6C6C]" />
                                                            </Button>
                                                            <Menu
                                                                id="basic-menu"
                                                                anchorEl={anchorEl}
                                                                open={menuOpen}
                                                                onClose={handleClose}
                                                                MenuListProps={{
                                                                    'aria-labelledby': 'basic-button',
                                                                }}
                                                            >
                                                                {/* <MenuItem onClick={(e) => handleViewClick(panelId, e)} sx={{ fontSize: 14 }}>View</MenuItem> */}
                                                                <MenuItem onClick={() => handleAddItemOpen(menuInvoice.property.id, menuInvoice.id)} sx={{ fontSize: 14 }}>Add Invoice Items</MenuItem>
                                                                <MenuItem sx={{ fontSize: 14 }}>Edit invoice</MenuItem>
                                                                <MenuItem onClick={() => handleConfirmation(menuInvoice?.id, 'invoice')} sx={{ fontSize: 14 }} className="!text-red-600">
                                                                    Delete
                                                                </MenuItem>
                                                            </Menu>
                                                        </div>
                                                    </Box>
                                                </Box>
                                            </AccordionSummary>

                                            <AccordionDetails className="!px-8">
                                                <Typography>
                                                    <div className='w-full overflow-x-auto'>
                                                        {expandedIndex === i && paymentStructures[expandedIndex].details.length > 0 ? (
                                                            <table className="table table-auto w-[100%] mt-10 overflow-x-auto">
                                                                <thead>
                                                                    <tr className='text-left bg-gray-200'>
                                                                        <th className='py-3 px-5'>S/N</th>
                                                                        <th>Title</th>
                                                                        <th>Description</th>
                                                                        <th>Amount</th>
                                                                        <th>Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        paymentStructures[expandedIndex].details.map((item, i) => {
                                                                            return (
                                                                                <tr className={`${i % 2 !== 0 && 'bg-gray-100'} border-b text-[16px]`}>
                                                                                    <td className='py-3 px-5'>{i + 1}</td>
                                                                                    <td>{item.title}</td>
                                                                                    <td>{item.description}</td>
                                                                                    <td>{item.amount}</td>
                                                                                    <td className='flex gap-4 items-center'>
                                                                                        {/* <EditIcon className='cursor-pointer' title="Add invoice item" /> */}
                                                                                        <IconButton title="Delete invoice item">
                                                                                            <DeleteIcon onClick={() => handleConfirmation(item?.id, 'invoice_item')} className='flex items-center cursor-pointer text-red-600' sx={{ fontSize: '20px' }} />
                                                                                        </IconButton>
                                                                                    </td>
                                                                                </tr>
                                                                            )
                                                                        })
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        ) : expandedIndex === i && paymentStructures[expandedIndex].details.length == 0 ? (
                                                            <div onClick={() => handleAddItemOpen(invoice.property.id, invoice.id)} className="pb-5 flex items-center justify-center border-dashed border-green-500 border text-green-500 mt-10 flex-col hover:cursor-pointer bg-white text-[18px]">
                                                                <span className='mt-4'>No item added - Click to add item</span>
                                                            </div>
                                                        ) : null
                                                        }
                                                    </div>
                                                </Typography>
                                            </AccordionDetails>
                                        </Accordion>
                                    )
                                })}
                            </div>
                        </div>
                    )
                }

                {errorText && <Button onClick={getInvoiceByType}>Try again</Button>}
                {
                    paymentStructures < 1 &&
                    <div className="pb-5 flex items-center justify-center border-dashed border-green-500 border text-green-500 mt-10 flex-col hover:cursor-pointer bg-white text-[18px]" onClick={handleClickOpen}>
                        <img src={PayImg} alt="" className='lg:w-[12%] md:w-[25%] w-[15%]' />
                        +  Create Payment Structure
                    </div>
                }
            </div>
            <div className='lg:px-10 md:px-3 min-h-[100vh]'>
                {/* Invoice Item Modal */}
                <Dialog open={invoiceOpen} onClose={handleClose}>
                    <DialogTitle>Create Invoice Item</DialogTitle>
                    <DialogContent className='overflow-x-hidden w-[100%]'>
                        <form onSubmit={formik2.handleSubmit}>
                            <div className="pt-5 items-center w-100 flex flex-col md:flex-row gap-3">
                                <TextField fullWidth id="standard-basic" label="Title" type='text' variant="outlined" name='title' value={formik2.values.title} onChange={formik2.handleChange} onBlur={formik2.handleBlur} error={formik2.touched.title && Boolean(formik2.errors.title)} helperText={formik2.touched.title && formik2.errors.title} />
                                <TextField fullWidth id="standard-basic" label="Description" type='text' variant="outlined" name='description' value={formik2.values.description} onChange={formik2.handleChange} onBlur={formik2.handleBlur} error={formik2.touched.description && Boolean(formik2.errors.description)} helperText={formik2.touched.description && formik2.errors.description} />
                                <TextField fullWidth id="standard-basic" label="Amount" type='text' variant="outlined" name="amount" value={formik2.values.amount} onChange={formik2.handleChange} onBlur={formik2.handleBlur} error={formik2.touched.amount && Boolean(formik2.errors.amount)} helperText={formik2.touched.amount && formik2.errors.amount} />
                            </div>
                            <div className="flex justify-end mt-3">
                                <button type='submit' disabled={!(formik2.isValid && formik2.dirty)} className={`px-4 py-2 border ${formik2.isValid && formik2.dirty ? 'bg-green-700' : 'bg-gray-400'
                                    } text-white flex items-center gap-2`}><p className='font-light text-[16px]'>Add Item</p>
                                </button>
                            </div>
                        </form>
                        <div className='w-full overflow-x-auto'>
                            {
                                invoiceItems.length > 0 ? (
                                    <table className="table table-auto w-[100%] mt-10 overflow-x-auto">
                                        <thead>
                                            <tr className='text-left bg-gray-200'>
                                                <th className='py-3 px-5'>S/N</th>
                                                <th>Title</th>
                                                <th>Description</th>
                                                <th>Amount</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                invoiceItems.map((item, i) => {
                                                    return (
                                                        <tr className={`${i % 2 !== 0 && 'bg-gray-100'} border-b text-[16px]`}>
                                                            <td className='py-3 px-5'>{i + 1}</td>
                                                            <td>{item.title}</td>
                                                            <td>{item.description}</td>
                                                            <td>{item.amount}</td>
                                                            <td className='flex gap-4 items-center'>
                                                                {/* <EditIcon className='cursor-pointer' title="Add invoice item" /> */}
                                                                <DeleteIcon className='flex items-center cursor-pointer text-red-600' sx={{ fontSize: '18px' }} onClick={() => handleDeleteItem(i)} />
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                ) : <div className="pb-5 flex items-center justify-center border-dashed border-green-500 border text-green-500 mt-10 flex-col hover:cursor-pointer bg-white text-[18px]">
                                    <span className='mt-4'>No item added</span>
                                </div>
                            }
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Cancel</Button>
                        {confirmLoading ? (
                            <Button disabled><SmallLoader /></Button>
                        ) : (
                            <Button onClick={handleInvoiceItemSave}>Save</Button>
                        )}
                    </DialogActions>
                </Dialog>
                {/* Delete Invoice Item Confirmation Dialog */}
                <Dialog
                    open={confirmationOpen}
                    onClose={() => setConfirmationOpen(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {"Delete invoice?"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Are you sure you want to delete this?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setConfirmationOpen(false)}>No</Button>
                        {title === 'invoice' &&
                            <Button sx={{ color: 'red' }} onClick={handleDeleteInvoice} autoFocus className='text-[#BD2424]'>
                                {!confirmLoading ? <span>Yes</span> : loader}
                            </Button>}
                        {title === 'invoice_item' &&
                            <Button sx={{ color: 'red' }} onClick={handleDeleteInvoiceItem} autoFocus className='text-[#BD2424]'>
                                {!confirmLoading ? <span>Yes</span> : loader}
                            </Button>}
                    </DialogActions>
                </Dialog>
                {/* Snackbar */}
                <Snackbar open={showToaster} autoHideDuration={6000} onClose={handleToasterClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
                    <Alert
                        onClose={handleToasterClose}
                        severity={toasterType}
                        variant="filled"
                        sx={{ width: '100%' }}
                    >
                        {message}
                    </Alert>
                </Snackbar>
            </div>
        </div>
    )
}

export default Payment